import React from 'react'
import PropTypes from 'prop-types'
import { allValidations } from 'utils/fieldValidationRules'
import { addFormsyValidationRule } from 'belle-js'
import OnboardingApp from 'components/Onboarding/App/App'
import ClientApp from 'components/Client/App/App'
import { isAppRoute } from 'routing/router/index'
import withLayout from 'components/Shared/withLayout/withLayout'
import OnboardingHeader from 'components/Onboarding/PWMHeader/PWMHeader'
import OnboardingModals from 'components/Onboarding/Modals/Modals'
import OnboardingSidebar from 'components/Onboarding/PWMSidebar/PWMSidebar'
import OnboardingFooter from 'components/Onboarding/OnboardingFooter/OnboardingFooter'
import ClientNavigation from 'components/Client/HeaderNavigation/HeaderNavigation'
import ClientFooter from 'components/Client/ClientFooter/ClientFooter'
import ErrorPage from 'components/ErrorPage/ErrorPage'
import ClientModals from 'components/Client/Modals/Modals'

for (const key in allValidations) {
  const validationName = key
  const validation = allValidations[key]
  addFormsyValidationRule(validationName, validation)
}

const OnboardingAppWithLayout = withLayout(
  OnboardingApp,
  OnboardingHeader,
  OnboardingFooter,
  OnboardingModals,
  OnboardingSidebar,
)

const ClientAppWithLayout = withLayout(ClientApp, ClientNavigation, ClientFooter, ClientModals)

const ErrorApp = withLayout(ErrorPage, null, ClientFooter)

const App = (props) => {
  const { location } = props
  const route = location.type

  let AppToRender = ErrorApp
  if (isAppRoute('onboarding', route)) {
    AppToRender = OnboardingAppWithLayout
  } else if (isAppRoute('client', route)) {
    AppToRender = ClientAppWithLayout
  }
  return <AppToRender {...props} />
}

App.propTypes = {
  location: PropTypes.object.isRequired
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx